import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import { VendorMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import type { VendorState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import {
  RadioGroupOption,
  RedoRadioGroup,
} from "@redotech/redo-web/arbiter-components/radio/redo-radio-group";
import { memo, useMemo, useState } from "react";

function matchTypeOptions(
  t: (key: string) => string,
): RadioGroupOption<VendorMatchType>[] {
  return [
    { id: VendorMatchType.ITEM, label: t("This item") },
    { id: VendorMatchType.ALL, label: t("All items in return") },
    { id: VendorMatchType.ANY, label: t("Any item in return") },
    { id: VendorMatchType.NONE, label: t("No items in return") },
  ];
}

export const VendorDetails = memo(function VendorDetails({
  state,
  setState,
  disabled,
  flowType,
}: ConditionTypeDetailsProps<VendorState>) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.vendors.map((tag) => ({ text: tag, color: "gray" as const })),
    [state.vendors],
  );

  const setVendors = useHandler((vendors: string[]) => {
    setState({ ...state, vendors });
  });

  return (
    <>
      {flowType === FlowType.RETURN_LOCATION && (
        <RedoRadioGroup
          disabled={disabled}
          options={matchTypeOptions(t)}
          setValue={(matchType) => setState({ ...state, matchType })}
          size="xs"
          value={state.matchType}
        />
      )}
      <RedoTagInputField
        delimiters={["newline"]}
        description={t("Vendors to match against")}
        inputValue={inputValue}
        label={t("Vendors")}
        placeholder={t("Type and press Enter to add")}
        setInputValue={setInputValue}
        setTags={setVendors}
        size="sm"
        state={disabled ? "disabled" : "default"}
        tags={tags}
      />
    </>
  );
});
